interface AlertState {
  isVisible: boolean
  message: string
  onOk?: () => void
}

export const useAlert = () => {
  const state = useState<AlertState>('alert', () => ({
    isVisible: false,
    message: '',
    onOk: undefined,
  }))

  const show = (message: string, onOk?: () => void) => {
    state.value = {
      isVisible: true,
      message,
      onOk,
    }
    // 스크롤 방지
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden'
    }
  }

  const close = () => {
    // 스크롤 복원
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
    state.value.isVisible = false
    state.value.onOk = undefined
  }

  return {
    state,
    show,
    close,
  }
}
